// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__JLXs7","segment":"SegmentedControl_segment__lvQxe","segmentActive":"SegmentedControl_segmentActive__+WSnL","icon":"SegmentedControl_icon__ztzoP"};